import {
  TextField,
  MenuItem,
  Box,
  Typography,
  InputAdornment,
  Switch,
  FormControlLabel,
} from '@mui/material'
import React from 'react'
import { grey } from '@mui/material/colors'
import useIsMobile from '../../hooks/useIsMobile'

const Key = ({
  value: {
    key,
    label,
    isDropdown,
    unique,
    options = [],
    type = 'text',
    adornment,
    getPlaceholder = () => {},
    readonly = false,
    getValue,
    getLabel,
    getShouldHide,
    required,
    getValueOnSelect,
    onChange,
    filterOptions,
  },
  keyIndex,
  getCanEditKey = () => true,
  item,
  editableKeys,
  width,
  canEdit,
  allowDuplicates,
  editItem,
  mergeEditItem,
  i,
  list,
  addItemOnEnter,
}) => {
  let value, isEmpty

  const canEditKey = getCanEditKey(key, item)

  const shouldHide = getShouldHide?.(item)

  const resolvedOptions = filterOptions ? filterOptions(options, item) : options

  const onKeyDown = (e) => {
    if (e.key === 'Enter' && i === list.length - 1) return addItemOnEnter()
  }

  if (shouldHide) {
    return (
      <Box sx={{ flexShrink: 0, ml: 1, width }} key={`hidden-${key}`}></Box>
    )
  }

  if (getValue) {
    const resolvedValue = getValue(item)

    value = resolvedValue[0]
    isEmpty = resolvedValue[1]
  } else if (item[key]) {
    value = item[key]
    isEmpty = false
  } else {
    value = ''
    isEmpty = true
  }

  const resolvedLabel = getLabel ? getLabel(item) : label

  if (readonly)
    return (
      <Box sx={{ flexShrink: 0, mx: 1, width }} key={`readonly-${key}`}>
        {isEmpty && (
          <i style={{ color: grey[500] }}>
            <Typography>{value}</Typography>
          </i>
        )}
        {!isEmpty && <Typography>{value}</Typography>}
      </Box>
    )

  if (type === 'boolean')
    return (
      <FormControlLabel
        sx={{ ml: 1 }}
        label={label}
        control={
          <Switch
            checked={value}
            onChange={(e) => {
              if (onChange) return onChange(item, e.target.checked)
              editItem(item, i, key, e.target.checked)
            }}
          />
        }
      ></FormControlLabel>
    )

  return (
    <TextField
      id={`list-editor-key-${i}`}
      onKeyDown={onKeyDown}
      required={required}
      sx={{
        ml: 1,
        width,
        minWidth: '150px',
      }}
      key={key}
      disabled={!canEdit || !canEditKey}
      value={value}
      margin={'dense'}
      label={resolvedLabel}
      onChange={(e) => {
        if (getValueOnSelect) {
          mergeEditItem(getValueOnSelect({ ...item, [key]: e.target.value }), i)
        }

        editItem(item, i, key, e.target.value)
      }}
      fullWidth
      select={isDropdown}
      type={type}
      InputLabelProps={
        type === 'date'
          ? {
              shrink: true,
            }
          : null
      }
      InputProps={{
        placeholder: getPlaceholder(item),
        startAdornment: adornment ? (
          <InputAdornment position='start'>{adornment}</InputAdornment>
        ) : null,
      }}
    >
      {isDropdown &&
        resolvedOptions.map((o) => (
          <MenuItem
            disabled={
              !allowDuplicates &&
              unique &&
              !!list.find((item) => item[key] === o.id)
            }
            key={`option-${o.id}`}
            value={o.id}
            {...(o.props || {})}
          >
            {o.name}
          </MenuItem>
        ))}
    </TextField>
  )
}

export default Key
